import {
  FAVORITES_SEASONS,
  FAVORITES_SEASON_VALUES,
  FAVORITES_SEASONS_WITH_NONE,
} from './seasons';

describe('FAVORITES_SEASONS', () => {
  it('includes grad2026 so promo images can be built for the grad season', () => {
    expect(FAVORITES_SEASON_VALUES).toContain('grad2026');
    const grad = FAVORITES_SEASONS.find((s) => s.value === 'grad2026');
    expect(grad).toEqual({ value: 'grad2026', label: 'grad2026' });
  });

  it('includes seniors2027 so designers can author senior looks', () => {
    expect(FAVORITES_SEASON_VALUES).toContain('seniors2027');
    const seniors = FAVORITES_SEASONS.find((s) => s.value === 'seniors2027');
    expect(seniors).toEqual({ value: 'seniors2027', label: 'seniors2027' });
  });

  it('has a non-empty value and label for every real season', () => {
    FAVORITES_SEASONS.forEach((s) => {
      expect(typeof s.value).toBe('string');
      expect(s.value.length).toBeGreaterThan(0);
      expect(typeof s.label).toBe('string');
      expect(s.label.length).toBeGreaterThan(0);
    });
  });

  it('has no duplicate season values', () => {
    const unique = new Set(FAVORITES_SEASON_VALUES);
    expect(unique.size).toBe(FAVORITES_SEASON_VALUES.length);
  });
});

describe('FAVORITES_SEASONS_WITH_NONE', () => {
  it('prepends a single "(none)" option and keeps the rest identical', () => {
    expect(FAVORITES_SEASONS_WITH_NONE[0]).toEqual({ value: '', label: '(none)' });
    expect(FAVORITES_SEASONS_WITH_NONE.slice(1)).toEqual(FAVORITES_SEASONS);
    // Exactly one empty-value option.
    const empties = FAVORITES_SEASONS_WITH_NONE.filter((s) => s.value === '');
    expect(empties).toHaveLength(1);
  });
});
